<template>
    <v-row>
        <v-col cols="12" v-if="!hideTitle">
            <div class="ob-title">{{ $t('entrance.sport_record') }}</div>
        </v-col>

        <v-col cols="12" v-for="field in sliderFields" :key="field.key">
            <div class="slider-header">
                <span class="slider-label">{{ field.label }}</span>
                <span class="slider-value">{{ field.value }}{{ field.units ? ` ${field.units}` : '' }}</span>
            </div>
            <input
                type="range"
                class="range-slider"
                :min="field.min"
                :max="field.max"
                :step="field.step"
                :value="field.value"
                :style="rangeStyle(field.value, field.min, field.max)"
                @input="onSlide(field.key, $event.target.value)"
            >
            <div class="slider-ticks">
                <span v-for="t in field.ticks" :key="t">{{ t }}</span>
            </div>
        </v-col>

        <v-col cols="12">
            <kimsa-combobox
                color="secondary"
                :label="$t('entrance.trained_sport')"
                :items="sportOptions"
                item-text="label"
                with-selected-dot
                :placeholder="$t('entrance.search_sport')"
                @change="sportSelected = $event"
                :value="sportSelected"
            />
        </v-col>
    </v-row>
</template>

<script>
import KimsaCombobox from "@/components/common/inputs/KimsaCombobox";
import {mapActions, mapState} from "vuex";

export default {
    name: "SportRecord",
    components: {KimsaCombobox},
    props: {
        hideTitle: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            height: 160,
            weight: 60,
            trainingDays: 0,
            sportSelected: '',
        }
    },
    computed: {
        ...mapState(['config']),
        sportOptions(vm = this) {
            if (!vm.config) return []
            return vm.config.sports.map(sport => ({name: sport, value: sport, label: vm.sportLabel(sport)}))
        },
        sliderFields(vm = this) {
            return [
                {key: 'height', label: vm.$t('entrance.height'), units: 'cm', min: 100, max: 200, step: 1, value: vm.height, ticks: vm.buildTicks(100, 200, 10)},
                {key: 'weight', label: vm.$t('entrance.weight'), units: 'kg', min: 40, max: 140, step: 1, value: vm.weight, ticks: vm.buildTicks(40, 140, 10)},
                {key: 'trainingDays', label: vm.$t('entrance.training_days'), units: '', min: 0, max: 7, step: 1, value: vm.trainingDays, ticks: vm.buildTicks(0, 7, 1)},
            ]
        },
        form(vm = this) {
            return {
                height: vm.height,
                weight: vm.weight,
                trainingDays: Number(vm.trainingDays),
                sportSelected: vm.sportSelected,
            }
        },
    },
    async mounted() {
        const vm = this
        if (!vm.config) await vm.bindConfig()
        vm.loadSportRecord()
    },
    methods: {
        ...mapActions(['bindConfig']),
        onSlide(key, value) {
            this[key] = Number(value)
        },
        rangeStyle(value, min, max) {
            const pct = ((value - min) / (max - min)) * 100
            return {'--pct': `${pct}%`}
        },
        buildTicks(min, max, by) {
            const ticks = []
            for (let i = min; i <= max; i += by) ticks.push(i)
            return ticks
        },
        loadSportRecord() {
            const vm = this
            vm.height = vm.account?.height || 160
            vm.weight = vm.account?.weight || 60
            vm.trainingDays = Number(vm.account?.trainingDays || 0)
            vm.sportSelected = vm.account?.sportSelected || ''
        }
    },
    watch: {
        account() {
            this.loadSportRecord()
        },
        form(val) {
            this.$emit('change', val)
        },
    }
}
</script>

<style scoped>

.ob-title {
    font-size: 26px;
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1.15;
}

.slider-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.slider-label {
    font-size: 14px;
    font-weight: 500;
}

.slider-value {
    font-size: 14px;
    font-weight: 700;
    color: var(--v-accent-base);
}

.range-slider {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    height: 4px;
    border-radius: 2px;
    background: linear-gradient(to right,
        var(--v-secondary-base) 0%,
        var(--v-secondary-base) var(--pct, 50%),
        var(--v-outline-base) var(--pct, 50%));
    outline: none;
    cursor: pointer;
}

.range-slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #fff;
    border: 2px solid var(--v-secondary-base);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
    cursor: pointer;
}

.range-slider::-moz-range-thumb {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #fff;
    border: 2px solid var(--v-secondary-base);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
    cursor: pointer;
}

.slider-ticks {
    display: flex;
    justify-content: space-between;
    padding: 0 1px;
    margin-top: 6px;
}

.slider-ticks span {
    font-size: 10px;
    color: var(--v-txtMuted-base);
}

</style>
